import {r as p} from '@theme/theme-sections';
const v = `<svg class="icon icon--star" aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 1.5L8.34708 5.6459H12.7063L9.17963 8.2082L10.5267 12.3541L7 9.7918L3.47329 12.3541L4.82037 8.2082L1.29366 5.6459H5.65292L7 1.5Z" fill="currentColor" stroke="currentColor" stroke-width="0.75" stroke-linecap="square"/>
</svg>
`,
  l = 'product-reviews';
var d, w, g;
const h =
    ((g = (w = (d = window.Shopify) == null ? void 0 : d.theme) == null ? void 0 : w.sections) == null
      ? void 0
      : g.registered) || {},
  _ = typeof h[l] > 'u',
  a = {
    anchors: '[data-reviews-anchor]',
    overview: '[data-reviews-overview]',
    writeReviewButton: '[data-write-review]',
    yotpoWriteReviewButton: '.write-question-review-buttons-container button',
    accordionTrigger: '[data-accordion-trigger]',
  };
_ &&
  p(l, {
    onLoad() {
      (this.config = {appKey: this.container.dataset.yotpoAppKey, productId: this.container.dataset.productId}),
        (this.strings = window.theme.strings.reviews),
        (this.elements = {
          overview: this.container.querySelector(a.overview),
          accordionTrigger: this.container.querySelector(a.accordionTrigger),
        }),
        this.initReviews(),
        this.handleAnchors();
    },
    handleAnchors() {
      const e = this.elements.accordionTrigger,
        t = document.querySelectorAll(a.anchors);
      !t.length ||
        !e ||
        t.forEach((o) => {
          o.addEventListener('click', () => {
            e.click();
          });
        });
    },
    async initReviews() {
      const e = await this.fetchYotpoReviews(),
        t = this.processReviews(e);
      this.updateOverview(t);
    },
    async fetchYotpoReviews(e = 1, t = 150) {
      const o = `https://api.yotpo.com/v1/widget/${this.config.appKey}/products/${this.config.productId}/reviews.json`,
        s = new URLSearchParams({page: e, per_page: t, sort: 'date', direction: 'desc'}),
        c = `${o}?${s}`;
      try {
        const n = await fetch(c);
        if (!n.ok) throw new Error(`HTTP error! status: ${n.status}`);
        return (await n.json()).response;
      } catch (n) {
        throw (console.error('Error fetching Yotpo reviews:', n), n);
      }
    },
    processReviews(e) {
      const t = {1: 0, 2: 0, 3: 0, 4: 0, 5: 0};
      return (
        e.reviews.forEach((o) => {
          const s = Math.floor(o.score);
          t[s]++;
        }),
        {total: e.bottomline.total_review, averageRating: e.bottomline.average_score, ratings: t}
      );
    },
    updateOverview(e) {
      const t = this.elements.overview,
        o = Object.entries(e.ratings)
          .sort((r, i) => i[0] - r[0])
          .map(([r, i]) => {
            const u = (i / e.total) * 100;
            return `
          <li class="product-reviews__overview-rating">
            <div class="product-reviews__overview-rating-star">
              ${v}
              ${r}
            </div>

            <div class="product-reviews__overview-rating-bar">
              <div class="product-reviews__overview-rating-bar-indicator ignore-empty" style="width: ${u}%;"></div>
            </div>

            <div class="product-reviews__overview-rating-count">
              ${i}
            </div>
          </li>
        `;
          }),
        s = e.averageRating.toFixed(2),
        c = () => {
          let r = 'all';
          return (
            s === 1 && (r = 'single'),
            s > 100 && (r = 'truncated'),
            this.strings.average_rating_description[r].replace('{{ count }}', e.total)
          );
        };
      (t.innerHTML = `
        <div class="product-reviews__overview-average">
          <div class="product-reviews__overview-average-rating">
            ${s}
            ${v}
          </div>

          <div class="product-reviews__overview-average-rating-description">
            ${c()}
          </div>
        </div>

        <button
          class="product-reviews__overview-write-review button button--secondary"
          data-write-review
          role="button"
        >
          ${this.strings.write_review}
        </button>

        <ul class="product-reviews__overview-ratings list-unstyled">
          ${o.join('')}
        </ul>
      `),
        t.querySelector(a.writeReviewButton).addEventListener('click', (r) => {
          r.preventDefault();
          const i = document.querySelector(a.yotpoWriteReviewButton);
          i == null || i.click();
        });
    },
  });
